import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ResellerPaymentLinkPage } from "./reseller-payment-link";
import { PipesModule } from "../../pipes/pipes.module";
import { ComponentsModule } from "../../components/components.module";

@NgModule({
  declarations: [ResellerPaymentLinkPage],
  imports: [
    IonicPageModule.forChild(ResellerPaymentLinkPage),
    PipesModule,
    ComponentsModule,
  ],
})
export class ResellerPaymentLinkPageModule {}



// WEBPACK FOOTER //
// ./src/pages/reseller-payment-link/reseller-payment-link.module.ts